module.exports = __webpack_public_path__ + "4181b96b1e856a8972ac0ba5ad091a05.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/critical-strike.png
// module id = 238
// module chunks = 0